import React, {useState} from 'react'
import styled from 'styled-components'
import {AUTHENTICATOR_OTP_LENGTH} from 'consts'
import {useTranslation} from 'i18n'
import {ObjectState} from 'types'
import {Button, InputOTP, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(16)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: 100%;
`
const StyledInputContainer = styled.div`
  margin: ${convertUnit(20)} 0;
`
const StyledLostAuthenticator = styled(Paragraph)`
  cursor: pointer;
`
const StyledError = styled(Paragraph)`
  margin-top: ${convertUnit(4)};
`

export interface GiftShopTemplateMFAInputProps {
  onCancel?(): void
  onConfirm(code: string): void
  stateLoading: ObjectState<boolean>
  stateError: ObjectState<string>
  stateShowRecovery?: ObjectState<boolean>
  onRecover?(): void
}

export default function GiftShopTemplateMFAInput({
  onConfirm,
  onCancel,
  stateError,
  stateLoading,
  stateShowRecovery,
  onRecover,
}: GiftShopTemplateMFAInputProps) {
  const {translate} = useTranslation()
  const [codes, setCodes] = useState('')
  const loading = stateLoading[0]
  const error = stateError[0]
  const showRecovery = stateShowRecovery && stateShowRecovery[0]

  return (
    <>
      <StyledTitle fontSize="l" fontWeight="bold">
        {translate('global:mfa')}
      </StyledTitle>
      <Paragraph fontSize="m">
        {translate('giftShop:settingAuthAppInputDesc', {
          length: AUTHENTICATOR_OTP_LENGTH,
        })}
      </Paragraph>
      <StyledInputContainer>
        <InputOTP
          boxes={AUTHENTICATOR_OTP_LENGTH}
          onSubmit={(code) => setCodes(code)}
          stateError={stateError}
        />
        {error && (
          <StyledError fontSize="m" fontWeight="medium" color="danger_5">
            {error}
          </StyledError>
        )}
      </StyledInputContainer>
      {showRecovery && (
        <StyledLostAuthenticator
          fontSize="m"
          fontWeight="bold"
          color="primary_5"
          onClick={onRecover}>
          {translate('giftShop:settingAuthAppRecoveryLost')}
        </StyledLostAuthenticator>
      )}
      <StyledButtonContainer>
        <StyledButton
          label={translate('global:cancel')}
          color="primary_5"
          backgroundColor="white_3"
          onClick={onCancel}
        />
        <StyledButton
          label={translate('global:verify')}
          disabled={codes.length < AUTHENTICATOR_OTP_LENGTH}
          isLoading={loading}
          onClick={() => onConfirm(codes)}
        />
      </StyledButtonContainer>
    </>
  )
}
